import { TAnalyticsNotesCommonState } from './types';

export function getForeignTradeTemplateData(state: TAnalyticsNotesCommonState) {
  return state.foreignTradeTemplateData;
}

export function getForeignTradeTable(state: TAnalyticsNotesCommonState) {
  return state.foreignTradeTable;
}

export function getExportStructureTable(state: TAnalyticsNotesCommonState) {
  return state.exportStructureTable;
}

export function getImportStructureTable(state: TAnalyticsNotesCommonState) {
  return state.importStructureTable;
}

export function getExportProductsTable(state: TAnalyticsNotesCommonState) {
  return state.exportProductsTable;
}

export function getImportProductsTable(state: TAnalyticsNotesCommonState) {
  return state.importProductsTable;
}
